module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"head":{"meta":{"description":"TODO:このページの説明文をここに記述する(※Googleの検索結果に表示されるのでよく考える事!)"}},"message":{"search_prefix":"検索結果","search_unit":"件","detail":"条件に一致する情報が見つかりませんでした。","change_contidtion":"条件を変更する"}}}')
  delete Component.options._Ctor
}
